export class FSxRestoreDestinationOntapRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageVirtualMachineId",
            "baseName": "storageVirtualMachineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeName",
            "baseName": "volumeName",
            "type": "string",
            "format": ""
        },
        {
            "name": "junctionPath",
            "baseName": "junctionPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSize",
            "baseName": "volumeSize",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageEfficiencyEnabled",
            "baseName": "storageEfficiencyEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FSxRestoreDestinationOntapRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
